import { combineEpics } from 'redux-observable';
import { deleteOrderCacheEpic } from './delete-order-cache';
import { loadOrderCacheEpic } from './load-order-cache';
import { createOrderCacheEpic } from './create-order-cache';

const ordersEpic = combineEpics(
  loadOrderCacheEpic,
  createOrderCacheEpic,
  deleteOrderCacheEpic
);

export default ordersEpic;